import russianImage from '@/assets/images/russian.png'
import asianImage from '@/assets/images/asian.png'
import frozenImage from '@/assets/images/frozen.png'
import grillImage from '@/assets/images/grill.png'
import dairyImage from '@/assets/images/dairy.png'
import sushiImage from '@/assets/images/sushi.png'
import fastfoodImage from '@/assets/images/fastfood.png'

const PRODUCT_TAG_ICONS = {
  spicy: 'pi pi-face-smile',
  recommended: 'pi pi-star',
  hit: 'pi pi-star-fill',
}

const RESTAURANT_TAG_ICONS = {
  recommended: 'pi pi-star',
  fast: 'pi pi-bolt',
  new: 'pi pi-sparkles',
}

const CUISINE_TYPES = {
  russian: russianImage,
  asian: asianImage,
  frozen: frozenImage,
  grill: grillImage,
  dairy: dairyImage,
  sushi: sushiImage,
  fastfood: fastfoodImage,
}

function normalizeSlugList(value) {
  if (!Array.isArray(value)) {
    return []
  }
  return value.map((item) => String(item ?? '').trim()).filter(Boolean)
}

export function mapCatalogMeta(raw = {}) {
  return {
    productTags: normalizeSlugList(raw.product_tags),
    cuisineTypes: normalizeSlugList(raw.cuisine_types),
    restaurantTags: normalizeSlugList(raw.restaurant_tags),
  }
}

export function buildFilterTagItems(slugs, { t, te }, { labelKeyPrefix, icons, defaultIcon }) {
  return slugs.map((slug) => {
    const key = `${labelKeyPrefix}.${slug}`
    const item = {
      id: slug,
      label: te(key) ? t(key) : slug,
    }
    const icon = icons?.[slug] ?? defaultIcon
    if (icon) {
      item.icon = icon
    }
    return item
  })
}

function buildHomeFilterTagsFromSlugs(slugs, { t, te }, config) {
  if (!slugs.length) {
    const item = { id: 'all', label: t('common.restaurantMenuSection.all') }
    if (config.defaultIcon) {
      item.icon = config.defaultIcon
    }
    return [item]
  }
  return buildFilterTagItems(slugs, { t, te }, config)
}

export function buildProductFilterTags(slugs, { t, te }) {
  return buildHomeFilterTagsFromSlugs(slugs, { t, te }, {
    labelKeyPrefix: 'adminCatalog.productTags',
    icons: PRODUCT_TAG_ICONS,
    defaultIcon: 'pi pi-list',
  })
}

export function buildRestaurantFilterTags(slugs, { t, te }) {
  return buildHomeFilterTagsFromSlugs(slugs, { t, te }, {
    labelKeyPrefix: 'adminRestaurant.restaurantTags',
    icons: RESTAURANT_TAG_ICONS,
    defaultIcon: 'pi pi-list',
  })
}

export function buildCuisineTypeTiles(slugs, { t, te }) {
  return slugs.map((slug) => {
    const key = `common.restaurantCategory.${slug}`
    return {
      id: slug,
      label: te(key) ? t(key) : slug,
      imageUrl: CUISINE_TYPES[slug],
    }
  })
}

export function filterByTag(list, tag) {
  if (!tag || tag === 'all') {
    return list
  }
  return list.filter((item) => item.tags?.includes(tag))
}
